import { takeEvery, takeLatest, fork, call, put, all, select } from 'redux-saga/effects';
import FetchService from 'service/FetchService';
import {actionMeta} from './meta';
import {responseObject} from 'storeState/helpers';
import {authToken} from './selectors';
import {authenticatedRequest} from 'storeState/auth/saga';
import {errorSafeSaga} from 'service/StoreService';

const ty = actionMeta.identifiers;
const api = actionMeta.urlBuilders;
const actions = actionMeta.actionCreators;

function* usersList(action) {
    const url = api.buildUsersListUrl(action.payload.params);
    const authGet = yield authenticatedRequest(FetchService.get);
    const {response, data} = yield call(authGet, {
        url: url,
        params: action.payload.params
    });
    const error = response.status !== 200;
    yield put(actions.usersListResponse({ payload: {data: data}, error: error }));
}

function* watchUsersList() {
    yield takeLatest(ty.USERS_LIST_REQUEST, errorSafeSaga(usersList));
}

function* userDelete(action) {
    const url = api.buildUserDeleteUrl({ user_id: action.payload.params.user_id });
    const authDel = yield authenticatedRequest(FetchService.delete);
    const {response, data} = yield call(authDel, {
        url: url,
        params: action.payload.params
    });
    const error = response.status !== 200;
    yield put(actions.userDeleteResponse({ payload: {data: data}, error: error }));
    yield put(actions.usersListRequest(action.payload.params));
}

function* watchUserDelete() {
    yield takeLatest(ty.USER_DELETE_REQUEST, errorSafeSaga(userDelete));
}

function* userCreate(action) {
    const url = api.buildUserCreateUrl();
    const authPost = yield authenticatedRequest(FetchService.post);
    console.log("action.payload.params", action.payload.params);
    console.log("action.payload.params.user", action.payload.params.user);
    const {response, data} = yield call(authPost, {
        url: url,
        params: action.payload.params.user
    });
    const error = response.status !== 200;
    yield put(actions.userCreateResponse({ payload: {data: data}, error: error }));
    yield put(actions.usersListRequest(action.payload.params));
}

function* watchUserCreate() {
    yield takeLatest(ty.USER_CREATE_REQUEST, errorSafeSaga(userCreate));
}

function* userUpdate(action) {
    const url = api.buildUserUpdateUrl({ user_id: action.payload.params.user_id });
    const authPut = yield authenticatedRequest(FetchService.put);
    const {response, data} = yield call(authPut, {
        url: url,
        params: action.payload.params.user
    });
    const error = response.status !== 200;
    yield put(actions.userUpdateResponse({ payload: {data: data}, error: error }));
    yield put(actions.usersListRequest(action.payload.params));
}

function* watchUserUpdate() {
    yield takeLatest(ty.USER_UPDATE_REQUEST, errorSafeSaga(userUpdate));
}


function* saga() {
  yield all([
    fork(watchUsersList),
    fork(watchUserDelete),
    fork(watchUserCreate),
    fork(watchUserUpdate),
  ])
}

export default saga;



// WEBPACK FOOTER //
// ./src/storeState/users/saga.js